import type { ReviewerEventBatch } from '../../shared/reviewerEventBatch';
import { requestJson } from './requestJson';

export async function postReviewerEvents(
  reviewerId: string,
  batch: ReviewerEventBatch
): Promise<{ accepted: { reactions: number; samples: number } }> {
  return await requestJson(`/api/reviewers/${encodeURIComponent(reviewerId)}/events`, {
    method: 'POST',
    body: JSON.stringify(batch)
  });
}
